define('usuario-dashboard-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('usuario.dashboard.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('UsuarioDashboard', ['$q', '$http', '$location', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, i18n, appRoute, notify, $multipart) {
      return {
      }
    }]);
});
